/**
 * @generated SignedSource<<8777a5d6cd67c793b9e906d4c88e102f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ToggleReportFavoriteInput = {
  reportId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type toggleReportFavoriteMutation$variables = {
  input: ToggleReportFavoriteInput;
};
export type toggleReportFavoriteMutation$data = {
  readonly toggleReportFavorite: {
    readonly savedReport: {
      readonly node: {
        readonly id: string;
        readonly favorite: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type toggleReportFavoriteMutation = {
  variables: toggleReportFavoriteMutation$variables;
  response: toggleReportFavoriteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleReportFavoritePayload",
    "kind": "LinkedField",
    "name": "toggleReportFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SavedReportTypeEdge",
        "kind": "LinkedField",
        "name": "savedReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SavedReportType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "favorite",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "toggleReportFavoriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "toggleReportFavoriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "927516ed6cc4dfa6fc9383e457ac6cc6",
    "id": null,
    "metadata": {},
    "name": "toggleReportFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation toggleReportFavoriteMutation(\n  $input: ToggleReportFavoriteInput!\n) {\n  toggleReportFavorite(input: $input) {\n    savedReport {\n      node {\n        id\n        favorite\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8bb1a06d19b507c3228cdd0889ca145";

export default node;
